/**
 * Column-header cell style for design-refresh tables inside SectionCards —
 * the table counterpart of DetailGrid's `dt` label styling.
 */
export const TABLE_HEADER_CELL_SX = {
  color: 'text.secondary',
  fontSize: '1.1rem',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  py: 1.25,
} as const
